import {
	Selections,
	SelectionsHeader,
	SelectionsHeaderActions
} from "./SkillsSelections.styled";
import { CrossIcon, InputLabel, WarningIcon } from "web-components";
import Search from '../../../../../components/new-ui/search';
import {Scrollbars} from 'react-custom-scrollbars';
import React, { useState } from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import {FeedbackButton} from "../../buttons/feedback-button";
import {FlexGroup, HoverItem, HoverShow, ItemDescription, ItemName, ItemNote, ItemWarning} from "../../modals/ItemList.styled";

export const SMALL = 'SMALL'
export const LARGE = 'LARGE'

export const SkillsSelections = ({
	skills,
	selectedSkills,
	onRemove,
	warningCallback = () => false,
	header = '',
	size = SMALL,
	hideSelectionHeaderActions = false,
	showGiveFeedback = false,
}) => {
	const {formatMessage} = useIntl();

	const skillById = _.keyBy(skills, skill => skill.id);

	const [searchValue, setSearchValue] = useState('');

	const getSearchString = skill =>
		[skill.name, skill.category?.name].map(string => string?.toLowerCase()).join(' ');

	const searchFilter = skill => {
		return getSearchString(skill).includes(searchValue.toLowerCase());
	};

	const selected = selectedSkills
		.map(selectedSkill => skillById[selectedSkill])
		.filter(Boolean)
		.filter(searchFilter)
		.sort((a, b) => a.name.localeCompare(b.name))
		.sort((a, b) => {
			const aWarning = !!warningCallback(a);
			const bWarning = !!warningCallback(b);
			return aWarning === bWarning ? 0 : aWarning ? -1 : 1;
		});
	return (
		<Selections size={size} data-cy={'skill-selections'}>
			<SelectionsHeader>
				{size!=='LARGE' && <InputLabel text={header} />}
				{size==='LARGE' && <div><h3>{header} </h3></div>}
				<SelectionsHeaderActions size={size}>
					{!hideSelectionHeaderActions && (<Search key={`selected-search`} value={searchValue} onChange={setSearchValue} />)}
					{showGiveFeedback && <FeedbackButton link={'https://experience.forecast.it/feedback-skills'} />}
				</SelectionsHeaderActions>
			</SelectionsHeader>
			<Scrollbars style={size===LARGE ? {height: Math.min(selected.length, 6)*43+'px'} :{height:'205px'}}>
				{selected.map((skill, index) => {
					const warning = warningCallback(skill);
					return (
						<HoverItem size={size} key={skill.id} data-cy={`selected-skill-${index}`}>
							<FlexGroup>
								{!!warning && <WarningIcon size={WarningIcon.SIZE.STANDARD} updated color={'#E01212'} />}
								<ItemDescription>
									<ItemName>{skill.name}</ItemName>
									{warning ? (
										<ItemWarning>{warning}</ItemWarning>
									) : (
										<ItemNote>{skill.category?.name || formatMessage({id: 'settings_skills.no_category'})}</ItemNote>
									)}
								</ItemDescription>
							</FlexGroup>
							<HoverShow>
								<CrossIcon size={CrossIcon.SIZE.STANDARD} color={'#000'} onClick={() => onRemove(skill)} cy={'clear-icon'} />
							</HoverShow>
						</HoverItem>
					);
				})}
			</Scrollbars>
		</Selections>
	);
}
